import { useState } from 'react';
import { useLocation} from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { checkEligibility } from '../utils/ageEligibility.js';

function AddPlayer() {
  const location = useLocation();
  const team = location.state?.team;

  const [fullName, setFullName] = useState('');
  const [dob, setDob] = useState('');
  const [photo, setPhoto] = useState(null);
  const [birthCert, setBirthCert] = useState(null);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const eligibility = dob ? checkEligibility(dob, team?.category) : null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const formData = new FormData();
      formData.append('teamId', team?.teamId);
      formData.append('fullName', fullName);
      formData.append('dob', dob);
      if (photo) formData.append('photo', photo);
      if (birthCert) formData.append('birthCert', birthCert);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/players/register`, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();

      if (res.ok) {
        setMessage({ type: 'success', text: `Player added! Age: ${data.eligibility.age}` });
        setFullName('');
        setDob('');
        setPhoto(null);
        setBirthCert(null);
      } else {
        setMessage({ type: 'error', text: data.error });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Could not reach server' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-brand-cream">
      <Sidebar />
      <div className="flex-1 p-6">
        <h1 className="text-2xl font-bold text-brand-red mb-4">Add Player</h1>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow p-5 max-w-sm space-y-3">
          <input
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full border rounded-lg p-2.5 text-base"
            required
          />

          <input
            type="date"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            className="w-full border rounded-lg p-2.5 text-base"
            required
          />

          {eligibility && (
            <p className={eligibility.eligible ? 'text-green-600 text-sm font-semibold' : 'text-red-600 text-sm font-semibold'}>
              {eligibility.eligible
                ? `Player is eligible for ${team?.category} (Age: ${eligibility.age})`
                : `${eligibility.reason} (Age: ${eligibility.age})`}
            </p>
          )}

          <div>
            <label className="text-sm text-gray-600">Player Photo</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setPhoto(e.target.files[0])}
              className="w-full border rounded-lg p-2 text-sm"
            />
          </div>

          {team?.category !== 'Girls' && (
            <div>
              <label className="text-sm text-gray-600">Birth Certificate</label>
              <input
                type="file"
                accept="image/*,.pdf"
                onChange={(e) => setBirthCert(e.target.files[0])}
                className="w-full border rounded-lg p-2 text-sm"
              />
            </div>
          )}

          {message && (
            <p className={message.type === 'success' ? 'text-green-600 text-sm' : 'text-red-600 text-sm'}>
              {message.text}
            </p>
          )}

          <button
            type="submit"
            disabled={loading || (eligibility && !eligibility.eligible)}
            className="w-full bg-brand-red text-white font-bold py-2.5 rounded-lg hover:bg-red-800 disabled:opacity-50"
          >
            {loading ? 'Saving...' : 'Add Player'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddPlayer;